import LinkToProfile from './LinkToProfile';
import NextClubPackage from './NextClubPackage';

const ClubSummary = (props) => {
  const { clubPackage, clubMembership, club, page } = props;
  return (
    <>
      {renderContent(club, page, clubPackage)}
      {!clubPackage && clubMembership && (
        <LinkToProfile clubMembership={clubMembership} />
      )}
      {clubPackage && (
        <NextClubPackage
          clubPackage={clubPackage}
          clubMembership={clubMembership}
        />
      )}
    </>
  );
};

const renderContent = (club, page, clubPackage) => {
  // Only render content on the signup or on the receipt if package doesnt exist
  if (page === 'Signup' || !clubPackage) {
    return <div dangerouslySetInnerHTML={{ __html: club.content }} />;
  }
  return null;
};

export default ClubSummary;
